import { Link, useLocation } from "react-router-dom";
import { Map, User, Shield, Store } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function NavItem({ to, icon: Icon, label, testid, active }) {
  return (
    <Link to={to} data-testid={testid} className={`flex-1 flex flex-col items-center justify-center gap-0.5 h-full press ${active ? "text-primary" : "text-muted-foreground"}`}>
      <Icon className="w-5 h-5" />
      <span className="text-[10px] font-medium">{label}</span>
    </Link>
  );
}

export default function BottomNav() {
  const { user } = useAuth();
  const loc = useLocation();
  return (
    <nav className="fixed bottom-0 inset-x-0 h-16 glass z-[1000] flex items-stretch border-t border-white/5" data-testid="bottom-nav">
      <NavItem to="/" icon={Map} label="Mapa" testid="nav-map" active={loc.pathname === "/"} />
      {user?.account_type === "adega" && (
        <NavItem to="/adega" icon={Store} label="Minha adega" testid="nav-adega" active={loc.pathname === "/adega"} />
      )}
      <NavItem to="/profile" icon={User} label="Perfil" testid="nav-profile" active={loc.pathname === "/profile"} />
      {user?.role === "admin" && (
        <NavItem to="/admin" icon={Shield} label="Admin" testid="nav-admin" active={loc.pathname === "/admin"} />
      )}
    </nav>
  );
}
